import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinus,
  faPlus,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import actions from "../../../redux/groceryList/action";
import "../Checkout.page.css";

const img_placeholder = require("../../../assets/images/prodotto.png");

class CartItemRow extends Component {
  incrementQty = () => {
    const { item } = this.props;
    const step = item.quantity_step ? item.quantity_step : 1;
    const qty = item.quantity + step;
    this.props.changeQuantity({
      quantity: qty,
      item: item,
    });
  };

  decrementQty = () => {
    const { item } = this.props;
    let qty = item.quantity;
    if (item.quantity_step) {
      if (qty > item.quantity_step) {
        qty -= item.quantity_step;
      }
    } else if (qty > 1) {
      qty--;
    }
    this.props.changeQuantity({
      quantity: qty,
      item: item,
    });
  };

  deleteProduct = () => {
    this.props.deleteProduct({
      item: this.props.item,
    });
  };

  getDisplayPrice = () => {
    const { item } = this.props;
    if (
      item.offer_price !== null &&
      item.offer_price !== undefined &&
      parseFloat(item.offer_price) > 0
    ) {
      return parseFloat(item.offer_price);
    }
    return parseFloat(item.price);
  };

  render() {
    const { item } = this.props;
    const imageSrc =
      item.images && item.images.length > 0 && item.images[0].image_file
        ? item.images[0].image_file
        : img_placeholder;
    const unitPrice = this.getDisplayPrice();
    const subtotal = item.currentPrice
      ? parseFloat(item.currentPrice)
      : unitPrice * item.quantity;

    return (
      <div className="co-item">
        <div className="co-item__img">
          <img
            src={imageSrc}
            alt={item.field1 || ""}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // previene il loop
              currentTarget.src = img_placeholder;
            }}
          />
        </div>
        <div className="co-item__info">
          <p className="co-item__name">{item.field1}</p>
          <span className="co-item__price">
            {item.no_price ? "" : `\u20AC ${unitPrice.toFixed(2)}`}
          </span>
        </div>
        <div className="co-item__qty">
          <button
            className="co-item__qty-btn"
            onClick={this.decrementQty}
            type="button"
          >
            <FontAwesomeIcon icon={faMinus} />
          </button>
          <input
            className="co-item__qty-input"
            type="text"
            value={item.quantity}
            readOnly
          />
          <button
            className="co-item__qty-btn"
            onClick={this.incrementQty}
            type="button"
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
        <span className="co-item__subtotal">
          {item.no_price ? "" : `\u20AC ${subtotal.toFixed(2)}`}
        </span>
        <button
          className="co-item__remove"
          onClick={this.deleteProduct}
          type="button"
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    groceryList: state.groceryList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeQuantity: (data) => dispatch(actions.changeQuantity(data)),
    deleteProduct: (data) => dispatch(actions.deleteProduct(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartItemRow);
